import React, { Component } from 'react';
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody } from 'reactstrap';

class SetupAutopayModal extends Component {
  render() {

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} size="md">
        <ModalHeader className="no-border" toggle={this.props.toggle}>Set Up Autopay</ModalHeader>
        <ModalBody className="pt-0">
          <FormGroup>
            <Label for="paymentAccount">Pay From Account</Label>
            <Input
              type="select"
              name="payment-account"
              id="paymentAccount"
              defaultValue="paymentAccount1"
            >
              <option value="paymentAccount1">Chase Bank ending 1234</option>
              <option value="newAccount">Add New Account</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="paymentDate">Monthly Autopay Date</Label>
            <Input
              type="date"
              name="payment-date"
              id="paymentDate"
            />
          </FormGroup>
          <FormGroup className="mb-1">
            <Label for="paymentAmount">Monthly Autopay Amount</Label>
            <Input
              type="select"
              name="payment-amount"
              id="paymentAmount"
              defaultValue="amountCurrent"
            >
              <option value="amountCurrent">Minimum Payment Amount</option>
              <option value="amountPrincipal">Full Balance Amount</option>
              <option value="amountOther">Other Amount</option>
            </Input>
          </FormGroup>
          <FormGroup check className="mb-2 mt-2">
            <Label check>
              <Input type="checkbox" id="checkbox2" />{' '}
              By checking this box you agree ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </Label>
          </FormGroup>
          <Button color="primary" className="w-100 mt-1" disabled>Set Up Autopay</Button>
        </ModalBody>
      </Modal>
    );
  }
}

export default SetupAutopayModal;
